import { FolioScrapperRequest } from "./FolioRequest";

export class ObtenerFolios extends FolioScrapperRequest {
   cantidad: number;
}
